import { render, staticRenderFns } from "./CoachTeamItem.vue?vue&type=template&id=fb06fa4e&scoped=true&"
import script from "./CoachTeamItem.vue?vue&type=script&lang=js&"
export * from "./CoachTeamItem.vue?vue&type=script&lang=js&"
import style0 from "./CoachTeamItem.vue?vue&type=style&index=0&id=fb06fa4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb06fa4e",
  null
  
)

export default component.exports